import { inject, Injectable, InjectionToken, type Provider } from '@angular/core';
import { BehaviorSubject, shareReplay, Subject } from 'rxjs';
import { COMMON_GRID_STANDARD_ROW_HEIGHT, CommonGridStandardRowHeight, commonGridStandardRowHeightOptions } from './standard-row-height';

export const COMMON_GRID_KEY = new InjectionToken<string>('local-storage-key');

export function provideCommonGridStandardRowHeightService(localStorageKey: string): Provider[] {
    return [CommonGridStandardRowHeightService, { provide: COMMON_GRID_KEY, useValue: localStorageKey }];
}

@Injectable()
export class CommonGridStandardRowHeightService {
    private readonly commonGridKey = inject(COMMON_GRID_KEY);
    private readonly localStorageKey: string = `${this.commonGridKey}-common-grid-row-height`;

    private rowHeight: Subject<CommonGridStandardRowHeight> = new BehaviorSubject(this.getIntialRowHeight());
    public rowHeight$ = this.rowHeight.asObservable().pipe(shareReplay({ refCount: true, bufferSize: 1 }));

    public setHeight(selectedStandardHeight: CommonGridStandardRowHeight): void {
        this.rowHeight.next(selectedStandardHeight);
        localStorage.setItem(this.localStorageKey, selectedStandardHeight.height.toString());
    }

    private getIntialRowHeight(): CommonGridStandardRowHeight {
        const userPreferredGridRowHeight = localStorage.getItem(this.localStorageKey);
        return (
            (userPreferredGridRowHeight
                ? commonGridStandardRowHeightOptions.find((option) => option.height === +userPreferredGridRowHeight)
                : COMMON_GRID_STANDARD_ROW_HEIGHT) ?? COMMON_GRID_STANDARD_ROW_HEIGHT
        );
    }
}
